module.exports = __webpack_public_path__ + "img/img_logo.e4fa77e3.png";